import { useState } from 'react'
import SaveStateModal from 'features/RiskManagement/QRA/Components/SaveStateModal'

/**
 * Button triggers save state modal that redirects to the saved state
 * on success with WIS create modal trigger in query string.
 */
const SaveStateAndRunScenarioButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <button
        className={[
          'px-4 py-2',
          'bg-lighthouseBlue',
          'text-white',
          'disabled:opacity-50',
          'rounded font-medium'
        ].join(' ')}
        onClick={() => setIsModalOpen(true)}
      >
        Save & Run New Scenario
      </button>
      <SaveStateModal
        isWISCreate
        isModalOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  )
}

export default SaveStateAndRunScenarioButton
